export const getFormMenuPermissionKeys = menuItem => [
  menuItem?.sMenuID,
  menuItem?.sGlobalID,
  menuItem?.sMenuName,
  menuItem?.sAction
].filter(Boolean);

export const mergeActionDenial = (currentStatus, action, disabled) => {
  if (!action) return currentStatus;

  return {
    ...currentStatus,
    [action]: Boolean(currentStatus?.[action] || disabled)
  };
};

export const isFormMenuItemDisabled = (
  menuItem,
  workflowStatus = {},
  transactionStatus = {},
  workflowControlled = false
) => {
  const authoritativeStatus = workflowControlled
    ? workflowStatus
    : transactionStatus;

  return getFormMenuPermissionKeys(menuItem).some(
    key => authoritativeStatus?.[key] === true
  );
};
